

















import { defineComponent } from "@vue/composition-api";
import VClamp from "vue-clamp";
import { isIOS } from "@/lib/browserUtils";
import BaseButton from "@/components/BaseButton";

export default defineComponent({
  name: "TextClamp",
  components: { BaseButton, VClamp },
  props: {
    tag: { type: String, default: "div" },
    autoresize: { type: Boolean, default: true },
    maxLines: { type: Number, default: 3 },
    maxHeight: { type: [String, Number] },
    ellipsis: { type: String, default: "... " },
    expanded: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    isIOS: { type: Function as () => Function, default: isIOS },
  },
  methods: {
    moreClick(e: Event, expand: Function) {
      e.stopPropagation();
      expand();
    },
  },
});
